import {combineReducers} from 'redux';
import crud from "./crud";
import crud_sap from "./crud_sap";

const rootReducer = combineReducers({
    crud,
    crud_sap
});

export default rootReducer;